/**
 * Loads full filter dropdown options for construction salary or bonus display
 * (independent of the currently filtered table rows).
 */

import { useState, useEffect, useCallback } from 'react';
import fileUploadService from '../../../../../services/FileUploadService';

export const useConstructionFilterOptions = (dataType: 'salary' | 'bonus' = 'salary') => {
  const [availableYears, setAvailableYears] = useState<number[]>([]);
  const [availableMonths, setAvailableMonths] = useState<number[]>([]);
  const [availablePeriods, setAvailablePeriods] = useState<string[]>([]);
  const [availableGenbas, setAvailableGenbas] = useState<string[]>([]);
  const [availableEmployees, setAvailableEmployees] = useState<string[]>([]);

  const loadFilterOptions = useCallback(async () => {
    try {
      if (dataType === 'bonus') {
        const [years, periods, genbas, employees] = await Promise.all([
          fileUploadService.getConstructionBonusAvailableYears(),
          fileUploadService.getConstructionBonusAvailablePeriods(),
          fileUploadService.getConstructionBonusAvailableGenbas(),
          fileUploadService.getConstructionBonusAvailableEmployees(),
        ]);
        setAvailableYears(years);
        setAvailableMonths([]);
        setAvailablePeriods(
          [...periods].sort((a, b) => Number(a) - Number(b) || String(a).localeCompare(String(b)))
        );
        setAvailableGenbas(genbas);
        setAvailableEmployees(employees);
        return;
      }

      const [years, months, genbas, employees] = await Promise.all([
        fileUploadService.getConstructionAvailableYears(),
        fileUploadService.getConstructionAvailableMonths(),
        fileUploadService.getConstructionAvailableGenbas(),
        fileUploadService.getConstructionAvailableEmployees(),
      ]);
      setAvailableYears(years);
      setAvailableMonths(months);
      setAvailablePeriods([]);
      setAvailableGenbas(genbas);
      setAvailableEmployees(employees);
    } catch (error) {
      console.error('Error loading construction filter options:', error);
    }
  }, [dataType]);

  useEffect(() => {
    loadFilterOptions();
  }, [loadFilterOptions]);

  return {
    availableYears,
    availableMonths,
    availablePeriods,
    availableGenbas,
    availableEmployees,
    loadFilterOptions,
  };
};
